import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import DataTableGrid from '../../../shared/formUtilities/useTable';
import { InitializeColumnsPromoCodeReport } from '../reportsColumn';
import { ReportsService } from '../reportsService';
import { DateHelper } from '../../../helpers/dateHelper';
import { useNavigate } from 'react-router-dom';
import { buildRegionizeRoute } from '../../../helpers/regionRouteHelper';
import { AppRoutes } from '../../../constants/appRoutes';

const PromoCodeReport = () => {
  const reportsService = new ReportsService();
  const [promoCodeReport, setPromoCodeReport] = useState([]);
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const columns = InitializeColumnsPromoCodeReport();
  const queryParameters = new URLSearchParams(window.location.search);
  const [pagination, setPagination] = useState({
    currentPage: 1,
    pageCount: 0,
    perPage: 10,
    totalCount: 0,
  });

  useEffect(() => {
    getAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryParameters.get('currentPage'), queryParameters.get('perPage')]);

  const getAll = () => {
    setloading(true);
    let currentPage = queryParameters.get('currentPage')
      ? parseInt(queryParameters.get('currentPage'))
      : 1;
    let perPage = queryParameters.get('perPage')
      ? parseInt(queryParameters.get('perPage'))
      : 10;
    reportsService
      .getPromoCodeReport(currentPage, perPage)
      .then((resp) => {
        setloading(false);
        setPagination({
          pageCount: resp.data.paging?.totalCount,
          currentPage: resp.data.paging?.currentPage,
          perPage: resp.data.paging?.perPage,
          totalCount: resp.data.paging?.totalCount,
        });
        setPromoCodeReport(resp.data?.promoCodeUsages);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  function onNavigate(currentPage, perPage) {
    navigate({
      pathname: buildRegionizeRoute(
        `${AppRoutes.Reports}/${AppRoutes.ReportPromoCode}`
      ),
      search: `?currentPage=${currentPage}&perPage=${perPage}`,
    });
  }

  const onPageSizeChange = (e) => {
    onNavigate(1, e);
  };

  const onPageChange = (e) => {
    onNavigate(e + 1, pagination.perPage);
  };

  const onDownloadCSV = () => {
    setloading(true);
    reportsService
      .exportPromoCodeReport()
      .then((resp) => {
        const date = DateHelper.formatDate(new Date());
        const fileName = `Promo-Code-Report-${date}.csv`;
        saveAs(resp.data, fileName);
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  return (
    <>
      <DataTableGrid
        showDownloadCSV={true}
        download={() => {
          onDownloadCSV();
        }}
        hideSerialNumbers
        pagination={pagination}
        name={'reportPromoCodeTbl'}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
        columns={columns}
        heading={'Promo Code Report'}
        records={promoCodeReport}
        isPagination={true}
        showEditColumnsButton={true}
        loading={loading}></DataTableGrid>
    </>
  );
};

export default PromoCodeReport;
